import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import Main from '../components/Screens/Main';
import Section from '../components/Screens/Section';
import Markdown from '../components/Richtext/Markdown';
import OEmbed from '../components/OEmbed/OEmbed';
import ImageHandler from '../utils/ImageHandler';
import SocialLinks from '../components/Global/SocialLinks';
import ArticleNav from '../components/Global/ArticleNav';

// ====

const NewsPost = (props) => {
  const { pageContext, blok } = props;
  let pageData;
  if (pageContext) {
    pageData = JSON.parse(pageContext.story.content);
  } else {
    pageData = blok;
  }
  const openGraph = {
    type: 'article',
    title: pageData.article_title,
    description: pageData.opening_copy,
    image: pageData.hero_image,
  };

  return (
    <Layout
      meta={pageData.meta}
      openGraph={openGraph}
      image={pageData.hero_image}
      background="green"
      size="short"
    >
      <Hero title="" size="short" />
      <Main>
        <Section marginBottom>
          <div className="col-12 col-md-11 col-lg-10 brand-col">
            <div className="card">
              <div className="card-body">
                {pageData.category && (
                  <p>
                    <span
                      className={`brand-label brand-label-${pageData.category}`}
                    >
                      {pageData.category}
                    </span>
                  </p>
                )}
                <h3 className="brand-font-caps mb-3">
                  {pageData.article_title}
                </h3>
                <p className="brand-text-grey brand-font-caps small">
                  Posted on{' '}
                  <Moment format="DD MMMM YYYY">
                    {pageData.published_date}
                  </Moment>
                </p>
                {pageData.opening_copy && (
                  <Markdown>{pageData.opening_copy}</Markdown>
                )}

                {pageData.article_copy &&
                  pageData.article_copy.map((slice) => {
                    switch (slice.component) {
                      case 'copy':
                        return <Markdown>{slice.copy}</Markdown>;
                      case 'image':
                        return (
                          <div className="mt-3 mb-4 mx-auto text-center">
                            <img
                              src={ImageHandler(
                                slice.source,
                                'fit-in/0x600/filters:fill(transparent)',
                              )}
                              alt=""
                            />
                          </div>
                        );
                      case 'embed':
                        return <OEmbed src={slice.embed_code} />;
                      default:
                        return null;
                    }
                  })}
              </div>
            </div>
          </div>
        </Section>
      </Main>
    </Layout>
  );
};

export default NewsPost;

NewsPost.propTypes = {
  pageContext: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

NewsPost.defaultProps = {
  pageContext: null,
  blok: null,
};
